export default __webpack_public_path__ + "static/media/chevron-up.e1b642eb.svg";